import { Component, OnInit, Input, input } from '@angular/core';
import { FilterDataService } from '../filter-data.service';
import { format } from 'date-fns'; // Para formatear fechas

@Component({
  standalone: false,
  selector: 'app-filter-calendar',
  templateUrl: './filter-calendar.component.html',
  styleUrls: ['./filter-calendar.component.scss']
})
export class FilterItemCalendarComponent implements OnInit {
  @Input() filterName: string;

  constructor(private dataService: FilterDataService) { }

  // Estructura de fechas
  dateRange: { start: Date | null; end: Date | null } = { start: null, end: null };

  ngOnInit() {
    // Si hay un filtro existente, asignarlo como valor inicial
    if (this.dataService.curFilter().length > 0) {
      const filter = this.dataService.masterArray[this.dataService.collapsed]?.Filters[0];
      if (filter) {
        this.dateRange.start = filter.from ? new Date(filter.from) : null;
        this.dateRange.end = filter.to ? new Date(filter.to) : null;
      }
    }

  }

  /**
   * Actualizar el filtro con las fechas seleccionadas.
   */
  onChange() {
    const formattedRange = {
      from: this.dateRange.start ? format(this.dateRange.start, 'yyyy-MM-dd') : '',
      to: this.dateRange.end ? format(this.dateRange.end, 'yyyy-MM-dd') : ''
    };

    // Actualizar el servicio con el nuevo rango
    this.dataService.curFilter()[0] = formattedRange;
  }
}
